import useFigurePanelId from "./useFigurePanelId";
import GetAppIcon from '@material-ui/icons/GetApp';
import AddImageIcon from './AddImageIcon';
import { CropDragContext } from './CropDragProvider';
import { useContext } from 'react';
import { useSelector, useStore } from 'react-redux';

import G from './Getters';
let color;// = "cyan";

let menuButtonStyle = { fontSize:12,
    //background:color,
    //color:(color?'white':'unset'),
    display:'flex',
    alignItems:'center',
    fontWeight:500,
  }

export default function InsertImageButton(){

  const figurePanelId = useFigurePanelId();
  let store = useStore();
  let state = store.getState();
  const {figurePanelType} = G.getFigurePanel(state,{figurePanelId});

  const { setCropIdsBeingDragged } = useContext(CropDragContext);

  if( figurePanelType !== "microscopy" ){
    return null;
  }


  

  return (
    <div class="sg-row">

      <div 
        style={menuButtonStyle} 
        class={"small-padding-left small-padding-right hoverable-blue round-corners small-margin-right"}
        button={"insert-image"}



        onClick={() => {
          setCropIdsBeingDragged([{
            regions:{},
            imageIdsByChannel:{},
            valueType:"crop"
          }])
        }}>
       
        <AddImageIcon/>
        {false && <span>&nbsp;Insert</span>}
        
      </div>
    </div>
  )
}
